import { MAX_ENTRIES_FOR_TREATMENT_TABLES } from '@components/app/TreatmentPage/consts'
import { ReviewBox } from '@components/primitives/ReviewBox'
import { Text } from '@components/primitives/Text'
import type { TreatmentTopicReview } from '@prisma/client'
import { useEffect, useState } from 'react'

export const TreatmentReviews = ({
  searchName,
  treatmentReviews,
}: {
  searchName: string
  treatmentReviews: Omit<
    TreatmentTopicReview,
    'createdAt' | 'updatedAt' | 'id' | 'treatmentTopicId'
  >[]
}) => {
  const [allVisible, setAllVisible] = useState(true)

  useEffect(() => {
    if (treatmentReviews.length > MAX_ENTRIES_FOR_TREATMENT_TABLES) {
      setAllVisible(false)
    }
  }, [])

  const reviewsToDisplay = allVisible
    ? treatmentReviews
    : treatmentReviews.slice(0, MAX_ENTRIES_FOR_TREATMENT_TABLES)

  if (!treatmentReviews.length) {
    return null
  }
  return (
    <div className='grid grid-cols-1 gap-4'>
      {reviewsToDisplay.map((review) => (
        <ReviewBox
          date={review.reviewDate}
          key={review.reviewText}
          ratingValue={review.ratingValue}
          reviewText={review.rewrittenReviews[0] ?? review.reviewText}
          subtitle={`${searchName} for ${review.condition}`}
        />
      ))}
      {!allVisible && (
        <Text
          className='underline'
          onClick={() => setAllVisible(true)}
          value='View All Reviews'
        />
      )}
    </div>
  )
}
